import React from 'react';
import PropTypes from 'prop-types';

import Banner from '../Banner';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@material-ui/core';
import { withNavigation } from '../../actions/navigation';

const ExistingSubscriptionBanner = ({
  subscription,
  navigateToSubscription
}) => {

  if( subscription ) {
    return <Banner
      actions={[
        {
          children: <FormattedMessage id="subscription.button.manageSubscription" />,
          onClick: () => navigateToSubscription(subscription.id)
        }
      ]}
    >
      <Typography>
        <FormattedMessage id="product.alreadyExistingSubscription.banner" />
      </Typography>
    </Banner>
  }

  return null;
}

ExistingSubscriptionBanner.propTypes = {
  subscription: PropTypes.object.isRequired,
  navigateToSubscription: PropTypes.func.isRequired,
}

export default withNavigation(
  ExistingSubscriptionBanner
);
  



// WEBPACK FOOTER //
// ./src/components/products/ExistingSubscriptionBanner.js